/**
 * Bygger malen som .xlsx i nettleseren (SheetJS, lastes dynamisk) og starter nedlastingen.
 * Alle celler er tekst (format @). SheetJS CE kan ikke skrive celleformatering, så overskriften er ikke fet.
 */
import type { ImportMal } from '@/services/api/import.api';

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const lagMalFil = async ({ overskrifter, eksempelrader }: ImportMal, filnavn: string): Promise<void> => {
  const XLSX = await import('xlsx');
  const ark = XLSX.utils.aoa_to_sheet([overskrifter, ...eksempelrader]);
  for (const adresse of Object.keys(ark)) {
    if (adresse.startsWith('!')) continue;
    ark[adresse].t = 's';
    ark[adresse].z = '@';
  }
  ark['!cols'] = overskrifter.map((o) => ({ wch: Math.max(16, o.length + 4) }));
  const bok = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(bok, ark, 'Mal');
  const bytes = XLSX.write(bok, { type: 'array', bookType: 'xlsx' });

  const url = URL.createObjectURL(new Blob([bytes], { type: XLSX_MIME }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filnavn;
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    a.remove();
    URL.revokeObjectURL(url);
  }
};
